import { Directive, AfterViewInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, RouterEvent, NavigationStart, NavigationEnd } from '@angular/router';

@Directive({
  selector: '[app-scroll-watcher]'
})
export class ScrollWatcherDirective {

  scrolls: IScrollState[] = [];
  curUrl: string;
  restoreInteral: number | null = null;

  constructor(private router: Router, private route: ActivatedRoute, private eleRef: ElementRef) {
    router.events
      .subscribe((event: RouterEvent) => {
        if (event instanceof NavigationStart) {
          this.curUrl = event.url;
          this.tryRestoreScrollPosition(this.curUrl);
        }
      });
  }

  ngAfterViewInit() {
    this.eleRef.nativeElement.addEventListener("scroll", () => {
      this.setScroll(this.curUrl);
    });
  }

  setScroll(url: string) {
    var curScroll = this.getScroll(url);

    if (!curScroll) {
      var newScroll = {
        url: url,
        position: this.eleRef.nativeElement.scrollTop
      };

      this.scrolls.push(newScroll);
    }
    else {
      curScroll.position = this.eleRef.nativeElement.scrollTop;
    }

  }

  getScroll(url: string): IScrollState | null {
    for (let scroll of this.scrolls) {
      if (scroll.url.toLowerCase() === url.toLowerCase()) {
        return scroll;
      }
    }

    return null;
  }

  clearTryRestore() {
    if (this.restoreInteral !== null) {
      window.clearInterval(this.restoreInteral);
    }
  }

  tryRestoreScrollPosition(url: string) {
    this.clearTryRestore();
    var numOfTries = 0;

    var foundScroll = this.getScroll(url);

    if (foundScroll && foundScroll.position !== 0) {
      this.restoreInteral = window.setInterval(() => {

        if (++numOfTries === 140) {
          this.clearTryRestore();
        }
        else if (this.eleRef.nativeElement.scrollHeight >= foundScroll.position) {
          this.eleRef.nativeElement.scrollTop = foundScroll.position;

          if (this.eleRef.nativeElement.scrollTop === foundScroll.position) {
            this.clearTryRestore();
          }
        }
      }, 100);
    }
  }

}

interface IScrollState {
  position: number;
  url: string;
}